/* eslint-disable */
import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button, Grid, CircularProgress } from '@mui/material';
import LoginCard from 'ui-component/cards/LoginCard';
import { auth, encryptLocalStorageData, toastifySuccess } from 'helper/Utility';
import { useNavigate } from 'react-router';
import { INVOICE_APICALL } from 'helper/api/api';
import bluelogo from '../../assets/images/bluelogo.png';
import Alert from '@mui/material/Alert';

function Login() {
  const [Email, SetEmail] = useState('');
  const [Password, SetPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [stage, setStage] = useState('login');
  const [otp, setOtp] = useState('');
  const [qrCode, setQrCode] = useState(null);
  const [tempToken, setTempToken] = useState(null);

  useEffect(() => {
    const authData = auth('admin');
    if (authData?.token && authData?.is2FAVerified && authData?.role === 'admin') {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [navigate]);

  // ── Step 1: Login ──────────────────────────────────────────────────────────
  const loginprocess = async () => {
    if (!Email || !Password) {
      setMsg('Please enter Email and Password');
      return;
    }
    setMsg(null);
    setLoading(true);

    try {
      const res = await INVOICE_APICALL('admin/adminLogin', 'post', { email: Email, password: Password });
console.log('Sending email:', Email, 'password:', Password);
      console.log('Login response:', res);

      if (res?.status === 200) {
        const dataParam = {
          token: res?.token,
          firstName: res?.data?.firstName,
          lastName: res?.data?.lastName,
          email: res?.data?.email,
          id: res?.data?._id,
          role: res?.data?.role,
        };

        if (res?.requires2FA === true) {
          setTempToken(res?.token);
          encryptLocalStorageData('admin-secret', { ...dataParam, is2FAVerified: false }, 'DoNotTryToAccess');

          if (res?.needs2FASetup === true) {
            await getQRCodeForSetup(res?.token);
          } else {
            setStage('verify2fa');
            setLoading(false);
          }
        } else {
          encryptLocalStorageData('admin-secret', { ...dataParam, is2FAVerified: true }, 'DoNotTryToAccess');
          toastifySuccess('Login successful!');
          navigate('/admin/dashboard', { replace: true });
        }
      } else {
        setMsg(res?.message || 'Login failed');
        setLoading(false);
      }
    } catch (error) {
      setMsg(error?.response?.data?.message || 'Login failed. Please try again.');
      setLoading(false);
    }
  };

  // ── Step 2a: Get QR Code ───────────────────────────────────────────────────
  const getQRCodeForSetup = async (token) => {
    if (!token) {
      setMsg('Authentication error. Please login again.');
      setStage('login');
      setLoading(false);
      return;
    }

    try {
      const res = await INVOICE_APICALL('admin/setup-2fa', 'post', {}, token);
      console.log('Setup 2FA response:', res);

      if (res?.status === 200 || res?.status) {
        setQrCode(res?.qrCode);
        setOtp('');
        setStage('setup2fa');
        setMsg(null);
      } else {
        setMsg(res?.message || '2FA setup failed. Please contact support.');
        setStage('login');
      }
    } catch (err) {
      setMsg(err?.response?.data?.message || err?.message || 'Failed to setup 2FA. Please try again.');
      setStage('login');
    } finally {
      setLoading(false);
    }
  };

  // ── Step 2b: Verify OTP — First time setup ────────────────────────────────
  const handleVerifyAndEnable2FA = async () => {
    if (!otp || otp.length !== 6) {
      setMsg('Please enter a valid 6-digit OTP.');
      return;
    }
    setMsg(null);
    setLoading(true);

    try {
      const tokenToUse = tempToken || auth('admin')?.token;

      if (!tokenToUse) {
        setMsg('Session expired. Please login again.');
        setStage('login');
        setLoading(false);
        return;
      }

      const res = await INVOICE_APICALL('admin/verify-2fa', 'post', { otp }, tokenToUse);
      console.log('Verify 2FA response:', res);

      if (res?.status === 200 || res?.status) {
        const currentAuth = auth('admin');
        encryptLocalStorageData(
          'admin-secret',
          { ...currentAuth, is2FAVerified: true, token: tokenToUse },
          'DoNotTryToAccess'
        );
        toastifySuccess(res?.message || '2FA enabled successfully!');
        navigate('/admin/dashboard', { replace: true });
      } else {
        setMsg(res?.message || 'Invalid OTP. Please try again.');
      }
    } catch (err) {
      setMsg(err?.response?.data?.message || err?.message || 'OTP verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };


// ── Step 2c: Verify OTP — Already setup users (HAR LOGIN PE) ─────────────
const handleVerifyOTP = async () => {
    if (!otp || otp.length !== 6) {
        setMsg('Please enter a valid 6-digit OTP.');
        return;
    }
    setMsg(null);
    setLoading(true);

    try {
        const tokenToUse = tempToken || auth('admin')?.token;

        if (!tokenToUse) {
            setMsg('Session expired. Please login again.');
            setStage('login');
            setLoading(false);
            return;
        }

        // ✅ Pehle: 'admin/verify-2fa' tha — ab naya endpoint
        const res = await INVOICE_APICALL('admin/validate-otp', 'post', { otp }, tokenToUse);

        if (res?.status === 200) {
            const currentAuth = auth('admin');
            encryptLocalStorageData(
                'admin-secret',
                { ...currentAuth, is2FAVerified: true, token: tokenToUse },
                'DoNotTryToAccess'
            );
            toastifySuccess('Login successful!');
            navigate('/admin/dashboard', { replace: true });
        } else {
            setMsg(res?.message || 'Invalid OTP. Please try again.');
        }
    } catch (err) {
        setMsg(err?.response?.data?.message || err?.message || 'OTP verification failed.');
    } finally {
        setLoading(false);
    }
};

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (stage === 'login') loginprocess();
      if (stage === 'setup2fa') handleVerifyAndEnable2FA();
      if (stage === 'verify2fa') handleVerifyOTP();
    }
  };

  const goBackToLogin = () => {
    setStage('login');
    setOtp('');
    setMsg(null);
    setQrCode(null);
    setTempToken(null);
  };

  return (
    <Grid
      className="bg_image"
      container
      spacing={1}
      justifyContent={'center'}
      alignItems={'center'}
      height={'100vh'}
    >
      <Grid item md={4} justifyContent={'center'} alignItems={'center'}>
        <LoginCard className="outer-divv">
          <Grid container spacing={1} justifyContent={'center'} alignItems={'center'}>
            <Grid item md={10} justifyContent={'center'} alignItems={'center'}>
              <Grid container spacing={1} justifyContent={'center'} alignItems={'center'}>

                {/* Logo */}
                <Grid item sm={12} xs={12}>
                  <div className="app-logog text-center">
                    <img src={bluelogo} alt="Logo" style={{ width: '190px', margin: 'auto', height: '26px' }} />
                  </div>
                </Grid>

                {/* ── STAGE: login ── */}
                {stage === 'login' && (
                  <>
                    <Grid item sm={12} xs={12} className="mt-3">
                      <div className="section-tittle text-center">
                        <h1 className="tittle text-center">Welcome!</h1>
                      </div>
                    </Grid>

                    <Grid item sm={12} xs={12} className="mt-3 mb-3">
                      <label><strong>Email</strong></label>
                      <FormControl fullWidth>
                        <OutlinedInput
                          placeholder="admin@example.com"
                          value={Email}
                          onChange={(e) => SetEmail(e.target.value)}
                          className="form-inpitcustomfiled"
                          onKeyDown={handleKeyDown}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item sm={12} xs={12}>
                      <label><strong>Password</strong></label>
                      <FormControl fullWidth>
                        <OutlinedInput
                          placeholder="Enter password"
                          type={showPassword ? 'text' : 'password'}
                          value={Password}
                          onChange={(e) => SetPassword(e.target.value)}
                          className="form-inpitcustomfiled"
                          onKeyDown={handleKeyDown}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton onClick={() => setShowPassword(p => !p)} edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>

                    {msg && (
                      <Grid item sm={12} xs={12} className="mt-2">
                        <Alert severity="error">{msg}</Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Button
                        className="w-100 editprofile mt-sm-3 mt-3 mx-auto"
                        onClick={loginprocess}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={20} color="inherit" /> : 'Login'}
                      </Button>
                    </Grid>
                  </>
                )}

                {/* ── STAGE: setup2fa ── */}
                {stage === 'setup2fa' && (
                  <>
                    <Grid item sm={12} xs={12} className="mt-3 text-center">
                      <h2 className="tittle" style={{ color: '#e53e3e' }}>⚠️ One-Time 2FA Setup</h2>
                      <p style={{ fontSize: 14, color: '#10b981', marginTop: 6, fontWeight: 'bold' }}>
                        This is a MANDATORY one-time setup. You will never see this again!
                      </p>
                      <p style={{ fontSize: 13, color: '#6b7280', marginTop: 6 }}>
                        1. Install <strong>Google Authenticator</strong> on your phone<br />
                        2. Tap <strong>"+"</strong> and scan the QR code below<br />
                        3. Enter the 6-digit code shown in the app
                      </p>
                    </Grid>

                    {qrCode ? (
                      <Grid item xs={12} className="text-center">
                        <img
                          src={qrCode}
                          alt="2FA QR Code"
                          style={{
                            width: 200,
                            height: 200,
                            margin: 'auto',
                            display: 'block',
                            borderRadius: 8,
                            border: '2px solid #e2e8f0',
                            padding: 10,
                          }}
                        />
                        <p style={{ fontSize: 12, color: '#6b7280', marginTop: 10 }}>
                          Can't scan? <strong>Contact administrator</strong>
                        </p>
                      </Grid>
                    ) : (
                      <Grid item xs={12} className="text-center">
                        <CircularProgress />
                        <p>Loading QR code...</p>
                      </Grid>
                    )}

                    <Grid item sm={12} xs={12} className="mt-3">
                      <label><strong>Enter 6-digit Code from Google Authenticator</strong></label>
                      <FormControl fullWidth>
                        <OutlinedInput
                          placeholder="000000"
                          value={otp}
                          inputProps={{
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            maxLength: 6,
                            style: { fontSize: '24px', textAlign: 'center', letterSpacing: '5px' },
                          }}
                          onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                          className="form-inpitcustomfiled"
                          onKeyDown={handleKeyDown}
                          autoFocus
                        />
                      </FormControl>
                    </Grid>

                    {msg && (
                      <Grid item xs={12}>
                        <Alert severity="error">{msg}</Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Button
                        className="w-100 editprofile mt-sm-3 mt-3 mx-auto"
                        onClick={handleVerifyAndEnable2FA}
                        disabled={loading || !qrCode}
                        style={{ backgroundColor: '#10b981', color: 'white' }}
                      >
                        {loading ? <CircularProgress size={20} color="inherit" /> : '✓ Activate 2FA Permanently'}
                      </Button>
                    </Grid>

                    <Grid item xs={12} className="text-center">
                      <Button
                        variant="text"
                        size="small"
                        onClick={goBackToLogin}
                        style={{ color: '#6b7280', fontSize: 12, marginTop: 4 }}
                      >
                        ← Back to Login
                      </Button>
                    </Grid>
                  </>
                )}

                {/* ── STAGE: verify2fa ── */}
                {stage === 'verify2fa' && (
                  <>
                    <Grid item sm={12} xs={12} className="mt-3 text-center">
                      <h2 className="tittle">🔐 Two-Factor Authentication</h2>
                      <p style={{ fontSize: 13, color: '#6b7280', marginTop: 6 }}>
                        Open <strong>Google Authenticator</strong> and enter the 6-digit code for this account.
                      </p>
                    </Grid>

                    <Grid item sm={12} xs={12} className="mt-3">
                      <label><strong>Enter 6-digit Code</strong></label>
                      <FormControl fullWidth>
                        <OutlinedInput
                          placeholder="000000"
                          value={otp}
                          inputProps={{
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            maxLength: 6,
                            style: { fontSize: '24px', textAlign: 'center', letterSpacing: '5px' },
                          }}
                          onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                          className="form-inpitcustomfiled"
                          onKeyDown={handleKeyDown}
                          autoFocus
                        />
                      </FormControl>
                    </Grid>

                    {msg && (
                      <Grid item xs={12}>
                        <Alert severity="error">{msg}</Alert>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Button
                        className="w-100 editprofile mt-sm-3 mt-3 mx-auto"
                        onClick={handleVerifyOTP}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={20} color="inherit" /> : '✓ Verify & Login'}
                      </Button>
                    </Grid>

                    <Grid item xs={12} className="text-center">
                      <Button
                        variant="text"
                        size="small"
                        onClick={goBackToLogin}
                        style={{ color: '#6b7280', fontSize: 12, marginTop: 4 }}
                      >
                        ← Back to Login
                      </Button>
                    </Grid>
                  </>
                )}

              </Grid>
            </Grid>
          </Grid>
        </LoginCard>
      </Grid>
    </Grid>
  );
}

export default Login;
